import { IDynamicFieldProps } from "@view/common/DynamicForm/DynamicFormContracts";
import useDynamicFieldValidator from "@view/common/DynamicForm/Hooks/useDynamicFieldValidator";
import useDynamicIcon from "@view/common/DynamicForm/Hooks/useDynamicIcon";
import useDynamicOptions from "@view/common/DynamicForm/Hooks/useDynamicOptions";
import validateRegexes from "@view/common/DynamicForm/Validators/validateRegexes";
import validateTextRequired from "@view/common/DynamicForm/Validators/validateTextRequired";
import { ReactNode, useState, useEffect } from "react";
import TextField from "../TextField";

export interface IDynamicTextFieldAttributes {
  icon?: string;
  required?: boolean;
  placeholder?: string;
  multiline?: boolean;
  tooltip?: string;
  maxLength?: number;
  regexes?: { expression: string }[];
  type?: "text" | "number" | "password" | "date";
  requiredIndicator?: ReactNode;
  optionsUrl?: string;
  optionsUrlQuery?: { [key: string]: string };
  messageError?: string;
  disabled?: boolean;
  disableArrows?: boolean;
}

export default function DynamicTextField(
  props: IDynamicFieldProps<string, string, IDynamicTextFieldAttributes>,
) {
  const inputId = `dynamic-text-${props.name}-id`;
  const Icon = useDynamicIcon(props.attributes?.icon);
  const [list, loading] = useDynamicOptions(props.attributes ?? {});
  const [disabled, setDisabled] = useState((props.attributes?.disabled || props.disabled) ?? false);
  useDynamicFieldValidator<string, IDynamicTextFieldAttributes>({
    validators: [validateTextRequired, validateRegexes],
    props,
  });

  useEffect(() => {
    if (list.length > 0) {
      props.onChange({
        type: "change",
        target: {
          name: props.name,
          value: list[0].value,
        }
      });
      setDisabled(true);
    } else if(props.attributes?.optionsUrl) {
      props.onChange({
        type: "change",
        target: {
          name: props.name,
          value: "",
        }
      });
    }
  }, [list])

  useEffect(() => {
    setDisabled((props.attributes?.disabled || props.disabled) ?? !disabled)
  },[props.attributes?.disabled, props.disabled])

  return (
    <div style={{ width: "100%" }}>
      <TextField
        requiredIndicator={
          props.attributes?.required && props.requiredIndicator
        }
        label={props.label}
        id={inputId}
        name={props.name}
        value={props.value ?? ""}
        error={props.error}
        disabled={disabled}
        onChange={props.onChange}
        onBlur={props.onBlur}
        maxLength={props.attributes?.maxLength}
        placeholder={props.attributes?.placeholder}
        multiline={props.attributes?.multiline}
        tooltip={props.attributes?.tooltip}
        type={props.attributes?.type}
        Icon={Icon}
        messageError={props.attributes?.messageError}
        disableArrows={props.attributes?.disableArrows}
      />
    </div>
  );
}
